import { createFileRoute } from '@tanstack/react-router';
import { MessageDetailsPage } from '@/features/messages/message-details-page.js';

export const Route = createFileRoute('/_app/messages/$id')({
  component: MessageDetailsPage,
});
